import { render, staticRenderFns } from "./Tablet.vue?vue&type=template&id=61a68fa8&scoped=true"
import script from "./Tablet.vue?vue&type=script&lang=js"
export * from "./Tablet.vue?vue&type=script&lang=js"
import style0 from "./Tablet.vue?vue&type=style&index=0&id=61a68fa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a68fa8",
  null
  
)

export default component.exports